// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"e03535cf","513":"8918e1a8","703":"3c7d459e","787":"633816a4"}[chunkId] + ".chunk.js";
};